import axios from "utils/axios";
import { API_BASE_URL, API_DASHBOARD } from "utils/constants";

export interface MultipleResultResponse {
  names: string[];
  values: string[];
}

const getCustomerQuantity = () =>
  axios.get(
    `${API_BASE_URL}${API_DASHBOARD.BASE_URL}/${API_DASHBOARD.CUSTOMER_QUANTITY_URL}`
  );
const getWeeklyPredictedValue = () =>
  axios.get(
    `${API_BASE_URL}${API_DASHBOARD.BASE_URL}/${API_DASHBOARD.WEEKLY_PREDICTED_VALUE_URL}`
  );
const getWeeklyPredictedQuantity = () =>
  axios.get(
    `${API_BASE_URL}${API_DASHBOARD.BASE_URL}/${API_DASHBOARD.WEEKLY_PREDICTED_QUANTITY_URL}`
  );
const getWeekScheduleAvailability = () =>
  axios.get(
    `${API_BASE_URL}${API_DASHBOARD.BASE_URL}/${API_DASHBOARD.WEEKLY_SCHEDULE_AVAILABILITY_URL}`
  );

const dashboardAPI = {
  getCustomerQuantity,
  getWeeklyPredictedValue,
  getWeeklyPredictedQuantity,
  getWeekScheduleAvailability,
};

export default dashboardAPI;
